import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Divider } from "antd";
import { TransactionOutlined, DollarCircleOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

function MenuManageAdvancePayment({ onClick }) {
  const navigate = useNavigate();
  const ROLE_ID = localStorage.getItem("ROLE_ID");

  const handleMenuClick = (item) => {
    if (onClick) onClick(item.label); // ส่งชื่อไปที่ Header
    navigate(item.path);
  };

  const menuGroups = [
    {
      groupTitle: "เงินทดรองจ่าย(ฟ้อง)",
      show:
        ROLE_ID === "1" ||
        ROLE_ID === "6" ||
        ROLE_ID === "14" ||
        ROLE_ID === "12",
      items: [
        {
          icon: <DollarCircleOutlined />,
          label: "เงินทดรองจ่าย > อนุมัติเบิก(ฟ้อง)",
          path: "/finance/advance-payment-lawsuit/aprove-withdraw-advance-payment",
          show: ROLE_ID === "1" || ROLE_ID === "6" || ROLE_ID === "14",
        },
        {
          icon: <TransactionOutlined />,
          label: "เงินทดรองจ่าย > อนุมัติเคลียร์(ฟ้อง)",
          path: "/finance/advance-payment-lawsuit/aprove-clear-advance-payment",
          show:
            ROLE_ID === "1" ||
            ROLE_ID === "6" ||
            ROLE_ID === "14" ||
            ROLE_ID === "12",
        },
      ],
    },
  ];

  return (
    <div className="dashboard-wrapper">
      {menuGroups.map(
        (group, gIndex) =>
          group.show && (
            <div key={gIndex}>
              <Divider orientation="left">
                <Title level={4}>{group.groupTitle}</Title>
              </Divider>
              <Row gutter={[24, 24]}>
                {group.items.map(
                  (item, index) =>
                    item.show && (
                      <Col xs={12} sm={8} md={6} lg={4} key={index}>
                        <div
                          className="menu-card"
                          onClick={() => handleMenuClick(item)}
                        >
                          <div className="icon-wrapper">{item.icon}</div>
                          <Text className="menu-text-gold">
                            {
                              item.label.includes(">")
                                ? item.label.split(">")[1] // ถ้ามี '>' ให้เอาตัวหลังสุดมาโชว์
                                : item.label // ถ้าไม่มีให้โชว์ปกติ
                            }
                          </Text>
                        </div>
                      </Col>
                    ),
                )}
              </Row>
            </div>
          ),
      )}
    </div>
  );
}

export default MenuManageAdvancePayment;
